/**
 * Куда рендерить разметку (задача Оли №427, 28.10.26: «кнопка “Разметка” не кликается, если открыт попап»).
 *
 * Окна приложения — `<dialog>.showModal()` (`shared/ui/Dialog.tsx`): модальный диалог уходит в верхний слой
 * браузера, а всё вне его поддерева становится inert. Никакой z-index кнопку не поднимет — она и не видна
 * поверх окна, и не кликается. Поэтому разметка рендерится ВНУТРЬ верхнего открытого окна, без окна — в body.
 *
 * Верхнее — последнее открытое в порядке документа: вложенное окно (выбор платья в «Загрузить») открывается
 * позже и лежит в DOM глубже внешнего. Координаты при переезде не меняются: всё у разметки `fixed` во вьюпорте,
 * а `transform` у `<dialog>` нет — значит, и внутри окна `fixed` считается от вьюпорта.
 */
export function annotHost<T>(openDialogs: ArrayLike<T>, body: T): T {
  return openDialogs.length > 0 ? openDialogs[openDialogs.length - 1]! : body;
}
